import { useState, useRef } from "react";
import moment from "moment";

import DatePicker from "../DatePicker/DatePicker";
import { ReactComponent as CaretLeft } from "../../assets/images/icons/caret-left.svg";
import { ReactComponent as CaretRight } from "../../assets/images/icons/caret-right.svg";
import { ReactComponent as CalenderActive } from "../../assets/images/icons/calendar-active.svg";

const DateNavigation = ({
  startDate,
  endDate,
  onDateChange,
  onShiftDates,
}) => {
  const [showCalendar, setShowCalendar] = useState(false);
  const buttonRef = useRef(null);

  const formatDateRange = (start, end) => {
    if (!start || !end) return "";

    const days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
    const months = [
      "Jan", "Feb", "Mar", "Apr", "May", "Jun",
      "Jul", "Aug", "Sep", "Oct", "Nov", "Dec",
    ];

    const startDay = days[start.getDay()];
    const startDateNum = start.getDate();
    const startMonth = months[start.getMonth()];

    const endDateNum = end.getDate();
    const endMonth = months[end.getMonth()];
    const endYear = end.getFullYear();

    if (
      start.getMonth() === end.getMonth() &&
      start.getFullYear() === end.getFullYear()
    ) {
      return `${startDay}, ${startDateNum} - ${endDateNum} ${endMonth} ${endYear}`;
    }

    return `${startDay}, ${startDateNum} ${startMonth} ${start.getFullYear()} - ${endDateNum} ${endMonth} ${endYear}`;
  };

  const handleRangeChange = (start, end) => {
    const startObj = start ? moment(start).toDate() : null;
    const endObj = end ? moment(end).toDate() : null;
    onDateChange?.(startObj, endObj);
  };

  return (
    <div className="flex items-center gap-2">
      {/* Previous Day Button */}
      <button
        onClick={() => onShiftDates?.(-1)}
        className="w-11 h-11 bg-app-card rounded-full flex items-center justify-center hover:opacity-50 transition-opacity"
        title="Previous day"
      >
        <CaretLeft className="w-5 h-5 text-[#FEFCEB]" />
      </button>

      {/* Next Day Button */}
      <button
        onClick={() => onShiftDates?.(1)}
        className="w-11 h-11 bg-app-card rounded-full flex items-center justify-center hover:opacity-50 transition-opacity"
        title="Next day"
      >
        <CaretRight className="w-5 h-5 text-[#FEFCEB]" />
      </button>

      {/* Calendar Button */}
      <div className="relative">
        <button
          ref={buttonRef}
          onClick={() => setShowCalendar(!showCalendar)}
          className="w-11 h-11 bg-app-card rounded-full flex items-center justify-center hover:opacity-50 transition-opacity"
          title="Select date range"
        >
          <CalenderActive className="w-5 h-5" />
        </button>

        <DatePicker
          selectsRange
          startDate={startDate ? moment(startDate).format("YYYY-MM-DD") : undefined}
          endDate={endDate ? moment(endDate).format("YYYY-MM-DD") : undefined}
          onRangeChange={handleRangeChange}
          open={showCalendar}
          onOpenChange={setShowCalendar}
          anchorRef={buttonRef}
          disablePastDates={false}
        />
      </div>

      {/* Date Display */}
      {startDate && endDate && (
        <div className="flex items-center">
          <p className="text-[#FEFCEB] text-[15px] font-medium m-0 leading-[1.3]">
            {formatDateRange(startDate, endDate)}
          </p>
        </div>
      )}
    </div>
  );
};

export default DateNavigation;
